import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Lokalny dev: kiedy REACT_APP_FIREBASE_AUTH_EMULATOR_URL jest ustawione, logowanie idzie
// do emulatora Firebase Auth zamiast do prawdziwego projektu. Bez tej zmiennej to no-op,
// więc build produkcyjny zachowuje się dokładnie jak wcześniej.
const authEmulatorUrl = process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_URL;

if (authEmulatorUrl) {
  connectAuthEmulator(auth, authEmulatorUrl, { disableWarnings: true });
}
